export default __webpack_public_path__ + "static/media/team_hero-mobile.png.webp";